var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3344 12.9294C11.673 14.5417 8.91975 15.6661 7.46459 17.1213C4.09126 20.4946 4.99247 26.7287 8.46502 27.9275C11.6647 29.0189 8.63864 23.2148 11.6647 20.6931C14.8727 18.2375 23.1324 22.5286 16.5098 28.126C14.9554 29.267 14.7239 29.6473 13.7152 30.656C8.29139 36.0798 17.0885 42.2229 23.5293 41.4374C29.2342 40.7429 30.7968 36.9975 31.5905 31.6647C32.3099 26.8031 31.3425 25.1082 32.0949 21.5777C34.5174 14.889 42.3472 20.5856 43.4468 23.8266C43.4716 23.4546 43.5047 23.0908 43.5047 22.7105C43.5047 11.2345 34.1949 1.9165 22.7025 1.9165C16.1212 1.9165 10.2674 4.98392 6.46417 9.75454C10.8545 7.01784 13.6986 9.63052 12.3344 12.9294Z",
    fill: "url(#paint0_radial_1603_29132)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8264 26.1111C31.7677 24.643 31.7155 23.3373 32.0946 21.5777C34.5171 14.8889 42.3386 20.5856 43.4548 23.8349C42.876 34.7982 33.8309 43.5209 22.7105 43.5209C11.2262 43.5209 1.9165 34.2029 1.9165 22.7187C1.9165 17.8158 3.61971 13.318 6.46389 9.7628C10.8542 7.01783 13.6984 9.63051 12.3342 12.9294C11.9363 13.9065 10.756 14.7057 9.56521 15.5119C8.80127 16.0292 8.03302 16.5494 7.46431 17.1213C4.09098 20.4946 4.99219 26.7287 8.46474 27.9275C10.093 28.4829 10.109 27.2526 10.1308 25.5779C10.1519 23.9616 10.1783 21.9315 11.6644 20.6931C14.8642 18.2375 23.1321 22.5285 16.5095 28.126C15.3071 29.0085 14.8963 29.436 14.305 30.0512C14.1319 30.2313 13.9433 30.4275 13.7149 30.656C8.29111 36.0798 17.0882 42.2229 23.529 41.4374C29.2339 40.7429 30.8048 37.0058 31.5903 31.6647C31.9511 29.2303 31.8854 27.5885 31.8264 26.1111ZM36.6087 15.4429C35.6496 16.7823 33.2684 16.6831 31.2758 15.2527C29.2915 13.8141 28.4564 11.5652 29.4073 10.2341C30.3664 8.90293 32.7641 8.99388 34.7484 10.4408C36.7327 11.8629 37.576 14.1118 36.6087 15.4429Z",
    fill: "url(#paint1_radial_1603_29132)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1603_29132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.6026 13.7304) scale(27.6259 28.6635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF402F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2057,
    stopColor: "#E0382B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5402,
    stopColor: "#C42225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#BE1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1113"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1603_29132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7225 12.5708) scale(26.9532 22.6513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005618,
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A9297"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/유진투자증권-46.8494ef8dd10e379fabbe304be869b928.svg";
export { ForwardRef as ReactComponent };